<template>
  <!-- Aviso Mobile -->
  <div class="aviso-mobile" v-if="isMobile">
    <div class="conteudo">
      <Svgs nome="levelmember-icone" />
      <h2>Edição Indisponível</h2>
      <p>A edição está ativada apenas para desktop</p>
      <button @click="router.push('/inicio')">Voltar</button>
    </div>
  </div>
  <div id="tela" v-else>
    <!-- Conteúdo Desktop -->
    <Teleport to="body">
      <SectionConfigurar />
      <SectionAlunos />
      <SectionConteudo />
      <CriarModulo />
      <CriarCurso />
      <CriarAula />
      <EditarModulo />
      <EditarCurso />
      <EditarAula />
      <CriarAluno />
      <VerAula />
    </Teleport>
    <TelaLogin v-if="storeEditar.telaSelecionada === 'telaLogin'" />
    <TelaLoading v-if="storeEditar.telaSelecionada === 'telaLoading'" />
    <TelaCursos v-if="storeEditar.telaSelecionada === 'telaCursosArea'" />
    <TelaCurso v-if="storeEditar.telaSelecionada === 'telaCurso'" />
    <TelaModulo v-if="storeEditar.telaSelecionada === 'telaModulo'" />
    <TelaAula v-if="storeEditar.telaSelecionada === 'telaAula'" />
    <TelaPerfil v-if="storeEditar.telaSelecionada === 'telaPerfil'" />
    <Menu v-if="storeEditar.telaSelecionada !== 'telaLogin' && storeEditar.telaSelecionada !== 'telaLoading'" />
  </div>
</template>

<script setup>
import { onMounted, inject, ref, onUnmounted, computed } from 'vue'
import { useStoreAreas, useStoreEditar } from '@stores'
import { useRouter } from 'vue-router'
import Svgs from '@svgs'

import SectionConfigurar from '@/components/editar/configuracoes/SectionConfigurar.vue'
import SectionAlunos from '@/components/editar/alunos/SectionAlunos.vue'
import SectionConteudo from '@/components/editar/conteudo/SectionConteudo.vue'
import CriarModulo from '@/components/editar/conteudo/modals/CriarModulo.vue'
import EditarModulo from '@/components/editar/conteudo/modals/EditarModulo.vue'
import CriarCurso from '@/components/editar/conteudo/modals/CriarCurso.vue'
import EditarCurso from '@/components/editar/conteudo/modals/EditarCurso.vue'
import CriarAula from '@/components/editar/conteudo/modals/CriarAula.vue'
import EditarAula from '@/components/editar/conteudo/modals/EditarAula.vue'
import CriarAluno from '@/components/editar/alunos/modals/CriarAluno.vue'
import VerAula from '@/components/editar/conteudo/modals/VerAula.vue'

import TelaLogin from '@/components/editar/personalizar/telas/Login.vue'
import TelaLoading from '@/components/editar/personalizar/telas/Loading.vue'
import TelaCursos from '@/components/editar/personalizar/telas/Cursos.vue'
import TelaCurso from '@/components/editar/personalizar/telas/Curso.vue'
import TelaModulo from '@/components/editar/personalizar/telas/Modulo.vue'
import TelaAula from '@/components/editar/personalizar/telas/Aula.vue'
import TelaPerfil from '@/components/editar/personalizar/telas/Perfil.vue'
import Menu from '@/components/editar/personalizar/telas/Menu.vue'

const storeAreas = useStoreAreas()
const storeEditar = useStoreEditar()
const router = useRouter()
const emitter = inject('emitter')

async function receberArea() {
  const hotlink = router.currentRoute.value.params.hotlinkArea
  await storeAreas.receberPorHotlink(hotlink)
  storeEditar.personalizacao = storeAreas.area?.personalizacao
}

const windowWidth = ref(window.innerWidth)

const isMobile = computed(() => {
  return windowWidth.value < 1000
})

const handleResize = () => {
  windowWidth.value = window.innerWidth
}

onMounted(() => {
  receberArea()
  emitter.on('atualizarArea', receberArea)
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
</script>

<style scoped>
#tela {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  position: fixed;
  top: 50px;
  left: 0;
  width: calc(100% - 320px);
  max-height: calc(100dvh - 50px);
  height: calc(100dvh - 50px);
  overflow-y: scroll;
  scrollbar-width: none;
}
#tela::-webkit-scrollbar {
  display: none;
}
.aviso-mobile {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: var(--cor-escuro-1);
  z-index: 999;
}
.aviso-mobile .conteudo {
  text-align: center;
  padding: 20px;
}
.aviso-mobile svg {
  width: 70px;
  min-width: 70px;
}
.aviso-mobile h2 {
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-branco);
  margin: 30px 0 10px 0;
}
.aviso-mobile p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-5);
}
.aviso-mobile button {
  font-family: var(--bold);
  font-size: var(--f2);
  color: var(--cor-marca);
  padding: 10px 20px;
  border-radius: 10px;
  background-color: var(--cor-escuro-2);
  margin: 15px 0 0 0;
  transition: all 0.3s;
}
.aviso-mobile button:hover {
  color: var(--cor-branco-fixo);
  background-color: var(--cor-marca);
}
</style>
